import envConfig from '@nile/home/src/Config/env';
import { init } from 'commandbar';
import * as Sentry from '@sentry/react';

const chameleon = require('@chamaeleonidae/chmln');

// Helper function to get subdomain
const getSubdomain = () => {
  const hostname = window.location.hostname;
  return envConfig.mode !== 'development' ? hostname.split('.')[0] : 'dev';
};

const setCookie = (token) => {
  document.cookie = `chatToken=${token}`;
};

const getCookieValue = (name) => {
  return document.cookie
    .match(RegExp(`${name}=.[^;]*`))
    ?.pop()
    ?.replace(`${name}=`, '');
};

const initChameleon = (config) => {
  const {
    userId,
    name,
    email,
    customerId,
    chargeBeePlanId,
    planName,
    subscriptionStatus,
    domain,
    accountType
  } = config?.user;
  chameleon.init(
    'SrO1LuY4Yq8lmM9S4o3tL6xdQaN1lCzp66QSyAMjW5EbFx-1TETLm-FI0I4F0XelNWzMdD',
    {
      fastUrl: 'https://fast.chameleon.io/',
      forceOverride: true,
      includedDomains: ['*']
    }
  );
  chameleon.identify(userId, {
    email: email,
    name: name,
    dcRegion: localStorage.getItem('dcRegion'),
    userId: userId,
    Subdomain: getSubdomain(),
    Plan: chargeBeePlanId,
    subscription_status: subscriptionStatus,
    accountUrl: window?.location?.origin,
    customerId: customerId,
    accountType: accountType
  });
};

function intercomInsert(
  user,
  thirdPartyKey,
  company,
  companyInfo = null,
  currentProduct
) {
  init('e7555266');

  if (thirdPartyKey) {
    window.Intercom('boot', {
      app_id: envConfig.intercomAppID,
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      dcRegion: localStorage.getItem('dcRegion'),
      accountId: user.userId,
      Subdomain: getSubdomain(),
      Plan: user.chargeBeePlanId,
      user_hash: thirdPartyKey?.getCurrentUserThirdPartyHashKey['ic-key'],
      subscription_status: user.subscriptionStatus,
      accountUrl: window.location.origin,
      customerId: user.customerId,
      portalDomain: companyInfo?.portalDomain,
      activatedDateTime: user?.subscriptionContext?.activatedDateTime,
      daysSinceActivated: user?.subscriptionContext?.daysSinceActivated,
      company: {
        id: user.customerId,
        name: user?.organizationContext?.name
      },
      productType: currentProduct,
      accountType: user?.accountType
    });
  }
}

const initMixpanel = (mixpanelConfig) => {
  const { user, currentProduct } = mixpanelConfig;
  const userObj = {
    $name: `${user?.firstName} ${user?.lastName}`,
    $email: user?.email,
    $distinct_id: user?.customerId,
    $user_id: user?.customerId,
    customerId: user?.customerId,
    domain: location?.host,
    subdomain: getSubdomain(),
    plan: user?.chargeBeePlanId,
    subscription_status: user?.subscriptionStatus,
    accountType: user?.accountType,
    productType: currentProduct
  };

  if (mixpanel) {
    mixpanel.init(envConfig.mixpanelKey, {
      api_host: envConfig.useranalyticsDomain,
      ignore_dnt: true
    });

    if (mixpanel.identify) {
      mixpanel.identify(user?.userId);
    }

    if (mixpanel.register_once) {
      mixpanel.register_once(userObj);
    }

    mixpanel.people.set_once(userObj);
    mixpanel.set_group('company_id', user?.customerId);
    mixpanel.set_group('Company_name', location?.host);
  }
};

function initSentry(user, flag) {
  if (
    process.env.NODE_ENV != 'development' &&
    !Sentry.getCurrentHub().getClient()
  ) {
    Sentry.init({
      dsn: envConfig.sentryUrl,
      integrations: flag.sentryReplay ? [new Sentry.Replay()] : [],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });
    Sentry.setUser({ userId: user?.userId });
  }
}

function loadBeamer(config) {
  // Set the Beamer config with the user ID
  window.beamer_config = {
    product_id: 'ZABJEGQx76907',
    user_id: config?.user?.userId,
    user_email: config?.user?.email,
    user_firstname: config?.user?.firstName,
    user_lastname: config?.user?.lastName,
    customerId: config?.user?.customerId,
    plan: config?.user?.chargeBeePlanId,
    subscription_status: config?.user?.subscriptionStatus,
    accountType: config?.user?.accountType,
    filter: config?.currentProduct
    // You can add more properties if needed
  };

  // Check if the script is already loaded
  if (!document?.getElementById('beamer-embed-script')) {
    const script = document?.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://app.getbeamer.com/js/beamer-embed.js';
    script.defer = true;
    script.id = 'beamer-embed-script'; // Prevent duplicate loading
    document?.head.appendChild(script);
  }
}

export { intercomInsert, initSentry, initChameleon, loadBeamer, initMixpanel };
